export const QUERY_VALUE_OPTIONS_BOOLEAN = ['true', 'false'];
export const QUERY_VALUE_OPTIONS_OS = ['Android', 'iOS'];
